/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_CommitInputs */

const cs_import_commit = /** @type {(inputs: Import_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdit import`)
};

const en_import_commit = /** @type {(inputs: Import_CommitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit import`)
};

/**
* | output |
* | --- |
* | "Commit import" |
*
* @param {Import_CommitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_commit = /** @type {((inputs?: Import_CommitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_CommitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_commit(inputs)
	return cs_import_commit(inputs)
});